// extracted by mini-css-extract-plugin
export default {"CreditBalance":"CreditBalance_CreditBalance__TJGTF","buttonRow":"CreditBalance_buttonRow__qsHtS","tableWrapper":"CreditBalance_tableWrapper__c-PfK"};